@if (videoLink) {
  <div
    #player
    class="loaded-video"
    [ngClass]="[
      video?.currentTime === 0 ? 'lazy-play' : '',
      iconPlayPause === 'icon-learniz-play-arrow' ? 'is-paused' : '',
    ]">
    <!--  canPlay with no methods is use to trigger the ref detector changes and show the duration on the player -->
    <video
      id="video-player"
      [src]="videoLink"
      (timeupdate)="onTimeUpdate()"
      (play)="onPlay($event)"
      (pause)="onPause($event)"
      (ended)="togglePlay()"
      (canplay)="showControl()"
      (loadedmetadata)="durationChange($event)"
      #video
      width="100%"></video>
    <!-- FULLSCREEN -->
    @if (control) {
      <div
        class="paused-overlay"
        [class.has-poster]="poster && video?.currentTime === 0"
        [style.background-image]="poster && video?.currentTime === 0 ? 'url(' + poster + ')' : ''">
        <button (click)="togglePlay()" class="video-button">
          <span id="icon-play-outline">
            <span id="icon-play-triangle"></span>
          </span>
        </button>
      </div>
      <div class="video-player-box">
        <div class="video-options">
          <button (click)="togglePlay()" class="video-button" id="video-button-play">
            <span [ngClass]="iconPlayPause"></span>
          </button>
        </div>
        <div class="video-timer">
          @if (duration - currentTime | time: '{min}:{sec}') {
            <span class="video-timer-span">
              {{ duration - currentTime | time: '{min}:{sec}' }}
            </span>
          }
          <mat-slider class="flex-1" min="0" [max]="video.duration" step="1" [disabled]="!controlEnabled">
            <input matSliderThumb [value]="video.currentTime" (valueChange)="setTimeSlider($event)" />
          </mat-slider>
          @if (currentTime | time: '{min}:{sec}') {
            <span class="video-timer-span">
              {{ currentTime | time: '{min}:{sec}' }}
            </span>
          }
        </div>
        <div class="video_volume_fullscreen">
          <div class="video-volume">
            <!-- toggleSliderVolume($event) -->
            <button class="video-button" id="video-button-volume" (click)="setVolumeOnOff()">
              <span [ngClass]="volumeIcon"></span>
            </button>
            @if (!sliderVolumeHide) {
              <div class="mat-slider-volume-box" [ngClass]="'direction-ver'">
                <mat-slider min="0" max="1" step="0.1" vertical id="video-slider-volume">
                  <input
                    matSliderThumb
                    [value]="video.volume"
                    (valueChange)="setVolume($event)"
                    (click)="stopPropagation($event)" />
                </mat-slider>
              </div>
            }
          </div>
          @if (!isIPhone) {
            <button (click)="toggleFullscreen()" class="video-button">
              <span [ngClass]="iconVideoSize"></span>
            </button>
          }
        </div>
      </div>
    }
  </div>
}
